export const LOADING_TEXT = "Загрузка..."
